import React from 'react';
import { Box, Stack, Skeleton } from '@mui/material';
import StyledButtonBase from 'views/rebranded-module/common/components/UI/EventAndRidesCardV2/EventAndRidesCardV2.styles';

const EventAndRidesCardV2Skeleton = () => {
  return (
    <StyledButtonBase>
      <Stack alignItems="start" width="100%" height="100%">
        {/* Image Container */}
        <Box className="EARCImgContainer">
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>

        {/* Content Section */}
        <Box className="ERCContent">
          <Box className="ERCLeftSideContent">
            <Box>
              {/* Title and Date Container for Mobile */}
              <Box mb={1.75} className="ERCTitleMobileContainer">
                {/* Title Skeleton */}
                <Skeleton variant="text" width="80%" height={32} />
                
                {/* Mobile Date Badge Skeleton */}
                <Box className=" showMOBILE">
                  <Skeleton variant="text" width={80} height={80} />
                </Box>
              </Box>

              {/* Date Info Item Skeleton */}
              <Box className="ERCInfoItem" mt={2}>
                <Skeleton 
                  variant="rectangular" 
                  width={20} 
                  height={20} 
                  sx={{ borderRadius: 1, mr: 1 }} 
                  className="ERCInfoIcon"
                />
                <Skeleton 
                  variant="text" 
                  width={180} 
                  height={20} 
                  className="ERCInfotext"
                />
              </Box>

              {/* Address Info Item Skeleton */}
              <Box className="ERCInfoItem" mt={1}>
                <Skeleton 
                  variant="rectangular" 
                  width={20} 
                  height={20} 
                  sx={{ borderRadius: 1, mr: 1 }} 
                  className="ERCInfoIcon"
                />
                <Skeleton 
                  variant="text" 
                  width={200} 
                  height={20} 
                  className="ERCInfotext"
                />
              </Box>
            </Box>

            {/* Button Skeleton */}
            <Box className="ERCBtnContainer">
              <Skeleton 
                variant="rectangular" 
                width={120} 
                height={36} 
                sx={{ borderRadius: 1 }} 
                className="ERCBtn"
              />
            </Box>
          </Box>

          {/* Date Badge for Tablet and Desktop */}
          <Box className=" showTabletAndDesktop">
            <Skeleton 
              variant="text" 
              width={80} 
              height={80} 
              className="ERCMonth"
            />
          
          </Box>
        </Box>
      </Stack>
    </StyledButtonBase>
  );
};

export { EventAndRidesCardV2Skeleton };